const widgetModal = {
  namespaced: true,
  state: {
    modal: null,
    widget: null,
    pageId: null
  },
  mutations: {
    setState(state, payload){
      if(payload.modal) state.modal = payload.modal;
      if(payload.widget) state.widget = payload.widget;
      if(payload.pageId) state.pageId = payload.pageId;
    },
    resetState(state){
      state.modal = state.widget = state.pageId = null;
    }
  },
  actions: {
    openModal({commit}, payload){
      commit('setState', payload);
      document.body.style.overflowY = 'hidden';
    },
    closeModal({commit}){
      commit('resetState');
      document.body.style.overflowY = '';
    }
  }
};

export default widgetModal;
